// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"f24d3129","68":"99e57999","96":"5df41651","102":"82d0f15b","122":"52b9f1c8","167":"227385f6","320":"3213d783","383":"9d405503","410":"0d3eec0e","495":"81b20ee5","529":"9a0641f2","704":"6e052a68","776":"be466629","872":"bdf390e3"}[chunkId] + ".chunk.js";
};